import { EntityReference } from '@sonar-software/sonar-ts-types';
import { SonarRecord } from '@ui/records';
import { PERISCOPE_ENTITY_COPY, PERISCOPE_ENTITY_RELATED_OBJECT_TYPES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';

export type RelatedObjectClickHandler = (relatedObject: EntityReference) => void;

export interface PeriscopeRelatedObjectsProps {
	onRelatedObjectClick?: RelatedObjectClickHandler;
	relatedObject: EntityReference;
}

export const PeriscopeRelatedObject: React.FC<PeriscopeRelatedObjectsProps> = ({
	onRelatedObjectClick,
	relatedObject
}) => {
	const { displayName, isActive, relationships, sonarObjectId } = relatedObject;

	const handleClick = useCallback(() => {
		if (onRelatedObjectClick) {
			onRelatedObjectClick(relatedObject);
		}
	}, [ relatedObject, onRelatedObjectClick ]);

	return (
		<SonarRecord
			isActive={ isActive }
			name={ displayName }
			onClick={ handleClick }
			sonarObjectId={ sonarObjectId }>
			{ relationships?.map(({ name, type }) => {
				const [ referencedBy, ...nameWithoutPrefix ] = name.split('.');
				const key = `${name}-${type}`;
				const objectName = type === PERISCOPE_ENTITY_RELATED_OBJECT_TYPES.LOOKUP ? displayName : referencedBy;
				const content = PERISCOPE_ENTITY_COPY.IS_LOOKUP_OF_OBJECT(nameWithoutPrefix.join('.'), objectName);

				return <div key={ key }>{ content }</div>;
			}) }
		</SonarRecord>
	);
};
